/** @jsxImportSource @emotion/react */
import classNames from 'classnames';
import { ChevronDown } from 'lucide-react';
import { Pages } from 'modules/navigation/domain/enums/pages';
import React from 'react';
import { useMatch } from 'react-router-dom';
import type { DivProps } from 'typings';
import UDColorableIcon from 'ud-ui/components/icon/colorable-icon';
import UDNavLink from 'ud-ui/components/link/nav-link';
import * as S from './styles';

interface IHeaderProps extends DivProps {
  isOpen?: boolean;
  showRecentlyAdded?: boolean;
  hasRecentlyAdded?: boolean;
}

function Header(props: IHeaderProps) {
  const { isOpen, showRecentlyAdded, hasRecentlyAdded, ...rest } = props;
  const isOnChampionship = useMatch(Pages.TOURNEYS.INDEX + '/*');

  if (!hasRecentlyAdded) {
    return (
      <UDNavLink to={Pages.TOURNEYS.INDEX} checkPath={Pages.TOURNEYS.INDEX + '/*'} variant="secondary" className={'flex px-10'}>
        <UDColorableIcon name="cup" size={16} componentProps={{ className: 'mr-2' }} />
        Турниры
      </UDNavLink>
    );
  }

  return (
    <S.MainBlock
      {...rest}
      className={classNames('nav-item d-flex align-items-center text subhead px-10', {
        active: isOnChampionship,
        'mb-2': !showRecentlyAdded,
      })}
    >
      <UDColorableIcon name="cup" size={16} componentProps={{ className: 'mr-2' }} />
      Турниры
      <div style={{ position: 'absolute', right: 40 }}>
        <ChevronDown
          size={16}
          style={{
            transform: isOpen ? 'rotate(180deg)' : 'rotate(0deg)',
            transition: 'transform 0.3s ease-in-out',
          }}
        />
      </div>
    </S.MainBlock>
  );
}

export default Header;
